/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Spin } from 'antd';

import { InfoItem } from '@molecules';
import { useEventsList } from '@api/hooks';

const EventHeader = ({ eventIdWa, errors }) => {
  const { events, isFetching } = useEventsList({ eventIdWa });
  const { name } = events?.data?.find((item) => item.eventIdWa === eventIdWa) || [];
  return (
    <Spin spinning={isFetching}>
      <InfoItem.WithError error={errors} size="large" description={name}>
        Flash Interviews
      </InfoItem.WithError>
    </Spin>
  );
};

const Item = ({ module, errors }) => {
  const { eventIdWa } = module.content;

  if (!eventIdWa) return <></>;

  return <EventHeader {...{ eventIdWa, errors }} />;
};

export default Item;
